'use es6';

import { AUTOMATIC_IMAGE_UPLOAD } from '../../constants/usageTracking';
import { getTrackInteraction } from '../../utils/usageTracking';
export function getUploadHandler({
  uploadFile,
  trackInteraction,
  usageTracker,
  appName,
  inpage,
  stripImageBlobs
}) {
  const _trackInteraction = getTrackInteraction({
    usageTracker,
    trackInteraction,
    appName,
    inpage
  });
  return function uploadHandler(editor, blobInfo, success, failure) {
    const handleComplete = response => {
      const file = response.objects[0];
      success(file.default_hosting_url);
      const blobSelector = `img[src="${blobInfo.blobUri()}"]`;
      const uploadedImage = editor.dom.select(blobSelector)[0];
      if (uploadedImage) {
        uploadedImage.setAttribute('width', file.width);
        uploadedImage.setAttribute('height', file.height);
      }
      editor.fire('change');
      editor.fire('uploadComplete');
    };
    const handleFailure = error => {
      console.error(error);
      failure(error);
      editor.fire('uploadFailure');
    };
    const handleProgress = evt => {
      const percentLoaded = Math.round(evt.loaded / evt.total * 90);
      editor.fire('uploadProgress', {
        percentLoaded
      });
    };
    const blob = blobInfo.blob();
    if (blob.type === 'image/svg+xml') {
      //early return to prevent uploading icons
      return;
    }
    if (stripImageBlobs) {
      // Strip newly pasted image blobs instead of uploading to the FM
      const blobSelector = `img[src="${blobInfo.blobUri()}"][data-mce-paste]`;
      const images = editor.dom.select(blobSelector);
      if (images.length > 0) {
        editor.dom.remove(images);
        // We need to fire a change event so consumers save updated content
        editor.fire('change');
        // We need to manually remove the blob URI from the editorUpload cache
        // so that subsequent upload attempts for the same image also fail
        editor.editorUpload.blobCache.removeByUri(blobInfo.blobUri());
        editor.fire('openDisallowedImageUploadAlert');
        const noUploadPermissionErr = new Error('Image upload failed due to missing `file-manager-write` scope');
        handleFailure(noUploadPermissionErr);
      }
      return;
    }
    uploadFile({
      file: blob,
      base64: blobInfo.base64()
    }, handleProgress).then(handleComplete).catch(handleFailure);
    _trackInteraction('tinymceEdit', AUTOMATIC_IMAGE_UPLOAD);
  };
}